/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import { connect } from "react-redux";
//table imports
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import Button from "../../../component/button";
import Delete from "@mui/icons-material/Delete";
import Input from "../../../component/inputpm";
import Collapse from "@mui/material/Collapse";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";
import { withTranslation } from "react-i18next";

import Tooltip from "@mui/material/Tooltip";
import Checkbox from "@mui/material/Checkbox";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import { Grid, Card } from "@mui/material";
import classes from "./createPackage.module.css";
import { EnterArrow } from "../../../component/icons/icons";
// import { withStyles } from '@mui/styles';

class ComponentVariants extends Component {
  state = {
    open: false,
    variantIndex: 0,
  };

  componentDidMount() {}

  onChange = (e, variantIndex, componentIndex) => {
    let controlName = e.target.name;
    let components = [...this.props.component];
    components[componentIndex].edit = true;
    let variant = components[componentIndex].variants[variantIndex];
    if (controlName === "price") {
      var newPrice = Number(e.target.value);
      if (variant.minimumPrice) {
        if (newPrice >= Number(variant.minimumPrice)) {
          variant.price =
            "" +
            (Math.round((newPrice + Number.EPSILON) * 100) / 100).toFixed(2);
        } else {
          let minPrice = Number(variant.minimumPrice);
          variant.price =
            "" +
            (Math.round((minPrice + Number.EPSILON) * 100) / 100).toFixed(2);
        }
      } else {
        variant.price =
          "" + (Math.round((newPrice + Number.EPSILON) * 100) / 100).toFixed(2);
      }
    } else {
      variant[e.target.name] = e.target.value;
    }
    if (controlName === "applySpecialPrice") {
      variant.promoApplied = !variant.promoApplied;
    }
    if (
      this.props.packageMode === "promo" &&
      (controlName === "price" || controlName === "featureCode")
    ) {
      if (variant.promoPrice && variant.promoPrice.length > 0) {
        variant.promoPrice[0].price = variant.price;
      } else {
        variant.promoPrice = [
          {
            name: variant.name,
            featureCode: variant.featureCode,
            price: variant.price,
          },
        ];
      }
      variant.promoApplied = true;
    }
    this.setState({ [this.props.componentName]: components });
    this.props.updateVariantData(e, components[componentIndex], variantIndex);
  };

  addVariantRow = () => {
    let components = [...this.props.component];
    if (!components[this.props.index].variants) {
      components[this.props.index].variants = [];
    }
    components[this.props.index].variants.push({
      name: "",
      price: "",
      description: "",
      featureCode: "",
    });
    this.setState({ [this.props.componentName]: components });
  };

  deleteVariant = (variantIndex) => {
    this.setState({ open: true, variantIndex: variantIndex });
  };

  dialogAction = (action) => {
    if (action) {
      let components = [...this.props.component];
      if (
        components[this.props.index].variants[this.state.variantIndex]
          .productId &&
        this.props.addToCatalog === "false"
      ) {
        components[this.props.index].variants.push({
          name: "",
          price: "",
          description: "",
          featureCode: "",
          deleteId:
            components[this.props.index].variants[this.state.variantIndex]
              .productId,
        });
      }
      components[this.props.index].edit = true;
      components[this.props.index].variants.splice(this.state.variantIndex, 1);
      this.setState({ open: false, [this.props.componentName]: components });
    } else {
      this.setState({ open: false });
    }
  };

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  render() {
    const { t } = this.props;
    const { classes: jssClasses } = this.props;
    return (
      <React.Fragment>
        <TableRow>
          <TableCell
            style={{
              paddingBottom: 0,
              paddingTop: 0,
              border: this.props.expandVariants ? "" : "none",
            }}
            colSpan={9}
          >
            <Collapse
              in={this.props.expandVariants}
              timeout="auto"
              unmountOnExit
            >
              <Box margin={1}>
                <TableContainer>
                  <Table size="small" aria-label="purchases">
                    {this.props.component[this.props.index].variants &&
                      this.props.component[this.props.index].variants.length >
                        0 && (
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">{t("NAME")}</TableCell>
                            <TableCell align="center">
                              {t("DESCRIPTION")}
                            </TableCell>
                            <TableCell align="center">{t("PRICE")}</TableCell>
                            <TableCell align="center">
                              {t("FEATURE_CODE")}
                            </TableCell>
                            {this.props.packageMode !== "promo" && (
                              <TableCell align="center">
                                {t("ACTION")}
                              </TableCell>
                            )}
                            {this.props.packageMode === "promo" && (
                              <TableCell align="center">
                                {t("APPLY_PRICE")}
                              </TableCell>
                            )}
                          </TableRow>
                        </TableHead>
                      )}
                    <TableBody>
                      {this.props.component[this.props.index].variants &&
                        this.props.component[this.props.index].variants.length >
                          0 &&
                        this.props.component[this.props.index].variants.map(
                          (opt, variantIndex) =>
                            !opt.deleteId && (
                              <React.Fragment key={variantIndex}>
                                <TableRow>
                                  <TableCell
                                    style={{ width: "30%" }}
                                    component="th"
                                    scope="row"
                                  >
                                    <Input
                                      name={"name"}
                                      value={opt.name}
                                      onChange={(event) =>
                                        this.onChange(
                                          event,
                                          variantIndex,
                                          this.props.index,
                                        )
                                      }
                                    />
                                  </TableCell>
                                  <TableCell
                                    style={{ width: "30%" }}
                                    component="th"
                                    scope="row"
                                  >
                                    <Input
                                      name={"description"}
                                      value={
                                        opt.description ? opt.description : ""
                                      }
                                      inputProps={{ rows: 1, cols: 31 }}
                                      multiline={true}
                                      onChange={(event) =>
                                        this.onChange(
                                          event,
                                          variantIndex,
                                          this.props.index,
                                        )
                                      }
                                    />
                                  </TableCell>
                                  <TableCell
                                    style={{ width: "15%" }}
                                    align="center"
                                  >
                                    {this.props.packageMode === "promo" ? (
                                      <Input
                                        name={"price"}
                                        type={"number"}
                                        value={opt.price}
                                        onChange={(event) =>
                                          this.onChange(
                                            event,
                                            variantIndex,
                                            this.props.index,
                                          )
                                        }
                                        onKeyDown={(event) => {
                                          // Intercept the letter "e" (Key code 69) and prevent its default behavior
                                          if (event.keyCode === 69) {
                                            event.preventDefault();
                                          }
                                          if (event.key === ",") {
                                            event.preventDefault();
                                          }
                                        }}
                                      />
                                    ) : (
                                      opt.price
                                    )}
                                  </TableCell>
                                  <TableCell
                                    style={{ width: "15%" }}
                                    align="right"
                                  >
                                    <Input
                                      name={"featureCode"}
                                      value={opt.featureCode}
                                      onChange={(event) =>
                                        this.onChange(
                                          event,
                                          variantIndex,
                                          this.props.index,
                                        )
                                      }
                                      disabled
                                    />
                                  </TableCell>
                                  {this.props.packageMode !== "promo" && (
                                    <TableCell align="center">
                                      <Tooltip title={t("DELETE_VARIANT")}>
                                        <Delete
                                          onClick={() => {
                                            this.deleteVariant(variantIndex);
                                          }}
                                        />
                                      </Tooltip>
                                    </TableCell>
                                  )}
                                  {this.props.packageMode === "promo" && (
                                    <TableCell align="right">
                                      <Tooltip title={t("APPLY_PRICE")}>
                                        <Checkbox
                                          name="applySpecialPrice"
                                          color="primary"
                                          checked={opt.promoApplied}
                                          // onClick={(event) => {
                                          //     props.changeTableData(event, row);
                                          //     changeTableData(event, row);
                                          // }}
                                          onClick={(event) =>
                                            this.onChange(
                                              event,
                                              variantIndex,
                                              this.props.index,
                                            )
                                          }
                                          inputProps={{
                                            "aria-label": "Add Promo",
                                          }}
                                        />
                                      </Tooltip>
                                    </TableCell>
                                  )}
                                </TableRow>
                                <TableRow>
                                  <TableCell
                                    style={{
                                      paddingBottom: 0,
                                      paddingTop: 0,
                                      border: true ? "" : "none",
                                    }}
                                    colSpan={5}
                                  >
                                    <Collapse
                                      in={true}
                                      timeout="auto"
                                      unmountOnExit
                                    >
                                      <Box margin={1}>
                                        <Card
                                          variant="outlined"
                                          className={
                                            "roundCorners " +
                                            classes.cartItemCard
                                          }
                                          style={{ padding: "0" }}
                                        >
                                          <Grid
                                            container
                                            className={classes.cardItemHeader}
                                          >
                                            <div
                                              className={
                                                classes.includedItemsTable
                                              }
                                              style={{ width: "100%" }}
                                            >
                                              <Table
                                                size="small"
                                                aria-label="purchases"
                                                className={
                                                  "newGlobalTable roundCorners"
                                                }
                                              >
                                                <TableBody>
                                                  <TableRow>
                                                    <TableCell colSpan={3}>
                                                      <b>
                                                        {t("OTHER_PRICES")} :{" "}
                                                        {opt.name}
                                                      </b>
                                                    </TableCell>
                                                  </TableRow>
                                                  {opt.otherPrices &&
                                                    opt.otherPrices.length >
                                                      0 &&
                                                    opt.otherPrices.map(
                                                      (price, pIndex) => (
                                                        <TableRow>
                                                          <TableCell>
                                                            <span
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                              }}
                                                            >
                                                              <EnterArrow />
                                                              {t(
                                                                price.priceType,
                                                              )}
                                                            </span>
                                                          </TableCell>
                                                          <TableCell>
                                                            {this.props
                                                              .packageMode !==
                                                            "promo" ? (
                                                              price.price
                                                            ) : (
                                                              <Input
                                                                size={"small"}
                                                                type={"number"}
                                                                name={"price"}
                                                                // placeholder={"Price"}
                                                                variant={
                                                                  "outlined"
                                                                }
                                                                style={{
                                                                  width:
                                                                    "100px",
                                                                  float: "left",
                                                                }}
                                                                onChange={(
                                                                  event,
                                                                ) => {
                                                                  this.props.changeVariantOtherPrice(
                                                                    event,
                                                                    this.props
                                                                      .productRow,
                                                                    opt,
                                                                    price.priceType,
                                                                  );
                                                                }}
                                                                onKeyDown={(
                                                                  event,
                                                                ) => {
                                                                  // Intercept the letter "e" (Key code 69) and prevent its default behavior
                                                                  if (
                                                                    event.keyCode ===
                                                                    69
                                                                  ) {
                                                                    event.preventDefault();
                                                                  }
                                                                }}
                                                                value={
                                                                  price.price
                                                                }
                                                                className={
                                                                  classes.tablePriceInput
                                                                }
                                                                //virtual price does not matter
                                                                disabled={
                                                                  // (row.variants && row.variants.length > 0 ? true : false) ||
                                                                  this.props
                                                                    .isAuxiliary ||
                                                                  this.props
                                                                    .selectedBucketId ===
                                                                    "PROD_COMP_PACKAGE"
                                                                }
                                                              />
                                                            )}
                                                            {price.priceType ===
                                                            "USAGE_CHARGE" ? (
                                                              <>
                                                                &nbsp;{t("RC")}{" "}
                                                                {`(per ${this.props.getPriceTenureUOM(price.priceTenureUOMDesc)})`}
                                                              </>
                                                            ) : (
                                                              <>
                                                                &nbsp;{t("NRC")}
                                                              </>
                                                            )}
                                                          </TableCell>
                                                          <TableCell>
                                                            &nbsp;
                                                          </TableCell>
                                                        </TableRow>
                                                      ),
                                                    )}
                                                </TableBody>
                                              </Table>
                                            </div>
                                          </Grid>
                                        </Card>
                                      </Box>
                                    </Collapse>
                                  </TableCell>
                                </TableRow>
                              </React.Fragment>
                            ),
                        )}
                      {this.props.component[this.props.index].variants ===
                        undefined && (
                        <TableRow>
                          <TableCell colSpan="6" align="center">
                            {t("NO_VARIENT_DEFINED_FOR_PRODUCT")}
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              {/* <Button onClick={() => { this.addVariantRow() }} style={{ float: 'right', marginBottom: '5px' }} color="primary">Add Variant</Button> */}
            </Collapse>
          </TableCell>
        </TableRow>

        {/* delete confirmation */}
        {/* <Dialog disableScrollLock={true} open={this.state.open} maxWidth="lg">
                    <DialogTitle id="form-dialog-title">{t('DELETE_VARIANT')}</DialogTitle>
                    <DialogContent>
                        {t('DELETE_VARIANT_CONFIRMATION_MESSAGE')}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={event => this.dialogAction(false)} color="primary">{t('NO')}</Button>
                        <Button onClick={event => this.dialogAction(true)} color="primary">{t('YES')}</Button>
                    </DialogActions>
                </Dialog > */}

        <Dialog
          disableScrollLock={true}
          maxWidth={"sm"}
          PaperComponent={this.draggableDialogPaper}
          fullWidth={true}
          open={this.state.open}
          aria-labelledby="delete-dialog-title"
          PaperProps={
            {
              // className: jssClasses.resizablePaper
            }
          }
        >
          <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
            {t("DELETE_VARIANT")}
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText>
              {t("DELETE_VARIANT_CONFIRMATION_MESSAGE")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(event) => this.dialogAction(false)}
              color="primary"
            >
              {t("CANCEL")}
            </Button>
            <Button
              onClick={(event) => this.dialogAction(true)}
              color="primary"
            >
              {t("YES")}
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

// const styles = {
//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '60vw',
//     },
// };

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //setErrorMessage: (errMsg, msgType) => dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(ComponentVariants));
